import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import BroadcastsIndex from './Index.vue';
import BroadcastEditor from './Editor.vue';
import BroadcastDetails from './Details.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.BROADCASTS,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/broadcasts'),
    name: 'broadcasts_index',
    component: BroadcastsIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/new'),
    name: 'broadcasts_new',
    component: BroadcastEditor,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/:broadcastId/edit'),
    name: 'broadcasts_edit',
    component: BroadcastEditor,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/:broadcastId'),
    name: 'broadcasts_details',
    component: BroadcastDetails,
    meta,
  },
];
